<template>
  <AuthBox>
    <template v-if="!emailTruncate">
      <h1 class="auth-title">{{ $t('content.login_title') }}</h1>
      <div class="auth-subtitle mb-6">{{ $t('content.login_subtitle') }}</div>
    </template>
    <template v-else>
      <h1 class="auth-title">{{ $t('content.login_to_delete_account') }}</h1>
      <div class="auth-subtitle mt-2 mb-6">{{ $t('content.login_to_delete_account_desc') }}</div>
      <div class="auth-subtitle mb-6" v-html="$t('content.login_to_delete_account_suggest', { email: emailTruncate })"></div>
    </template>
    <form @submit.prevent="submit">
      <form-group :name="$t('form.email')" :validator="$v.form.email">
        <template slot-scope="{ attrs }">
          <v-text-field v-model="form.email" v-bind="attrs" :label="$t('form.email')" @input="$v.form.email.$touch()" @blur="$v.form.email.$touch()">
            <template #prepend-inner>
              <svg-icon icon="email" class="primary--text mr-3" />
            </template>
          </v-text-field>
        </template>
      </form-group>
      <form-group :name="$t('form.password')" :validator="$v.form.password">
        <template slot-scope="{ attrs }">
          <v-text-field
            v-model="form.password"
            v-bind="attrs"
            :append-icon="!showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('form.password')"
            @click:append="showPassword = !showPassword"
            @input="$v.form.password.$touch()"
            @blur="$v.form.password.$touch()"
            autocomplete="on"
          >
            <template #prepend-inner>
              <svg-icon icon="lock" class="primary--text mr-3" />
            </template>
          </v-text-field>
        </template>
      </form-group>
      <router-link v-if="!emailTruncate" :to="{ name: 'AuthForgotPass' }" class="my-3 d-block mb-10 forgot" style="text-decoration: none;">
        {{ $t('forgot_password') }}
      </router-link>
      <v-btn block color="primary btn-primary-custom mb-6" type="submit" :loading="loading">{{ $t('content.login_button') }}</v-btn>
      <template v-if="!emailTruncate">
        <v-divider class="mt-5 mb-5" />
        <GoogleLoginButton :clientId="client_id" @success="onSuccess" @failure="onFailure" />

        <!-- <div>
          <span class="dont-have-an-accoun">
            {{ $t('content.signup_1') }}
            <router-link :to="{ name: 'AuthRegister' }" style="text-decoration: none;">
              {{ $t('content.signup') }}
            </router-link></span
          >
        </div> -->
      </template>
    </form>
  </AuthBox>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';
import FormGroup from '@/components/base/FormGroup';
import AuthBox from '@/components/base/AuthBox';
import GoogleLoginButton from '@/components/base/GoogleLoginButton.vue';
import { decodeJwt } from '@/helper/jwt';
import socketChat from '@/plugins/socketChat';

export default {
  name: 'AuthLogin',
  components: {
    AuthBox,
    FormGroup,
    GoogleLoginButton
  },
  validations: {
    form: {
      email: { required, email },
      password: { required }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'Auth/isAuthenticated',
      currentRole: 'Auth/currentRole',
      items: 'ChildList/items'
    }),
    isProcessDeleteAccount() {
      return this.$route.query.process === 'deleteAccount' && this.$route.query.email;
    }
  },
  data: () => ({
    form: {
      email: '',
      password: ''
    },
    loading: false,
    loadingGoogle: false,
    showPassword: false,
    client_id: process.env.VUE_APP_OAUTH,
    emailTruncate: null
  }),
  methods: {
    onSuccess(credential) {
      const user = decodeJwt(credential);
      let regis = {
        registrationToken: user.sub
      };
      this.loadingGoogle = true;
      this.$store
        .dispatch(`Auth/loginGoogle`, regis)
        .then(({ roleId, verified, student, classroomStatus, classroomStatusDetail, cerdasTypeId }) => {
          if (roleId === 1 && verified) {
            this.$router.push({ name: 'ReportAdminIndex' });
          } else if (roleId === 2 && verified) {
            this.$router.push({ name: 'MasterUserSchool' });
          } else if (roleId === 6 && verified) {
            this.$router.push({ name: 'StudentIndex' });
          } else if (roleId === 3 && verified && student == true && classroomStatus == true) {
            this.$router.push({ name: 'ChildList' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == true && classroomStatusDetail == true) {
            this.$router.push({ name: 'ParentClassIndex' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == true && classroomStatusDetail == false) {
            this.$router.push({ name: 'ChildList' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == false) {
            this.$router.push({ name: 'ParentClassIndex' });
          } else if (roleId === 4 && verified && cerdasTypeId === 1) {
            this.$store.commit('Auth/SET_GUIDE_POP', { guidePopUp: true });
            this.$router.push({ name: 'CourseIndex' });
          } else if (roleId === 4 && verified && cerdasTypeId === 2) {
            this.$router.push({ name: 'TeacherClassIndex' });
          } else if (roleId === 5 && verified) {
            this.$router.push({ name: 'StudentClassIndex' });
          } else if (roleId && !verified) {
            this.$router.push({ name: 'AuthChangePassword' });
          }
          localStorage.setItem('notif', 0);
        })
        .finally(() => {
          this.loadingGoogle = false;
          this.$v.$reset();
          // setTimeout(() => this.$router.go(), 100);
        });
    },
    onFailure() {
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return false;

      if (this.isProcessDeleteAccount) {
        this.verifyDeleteAccount();
        return;
      }

      socketChat.disconnect();
      this.loading = true;
      this.$store
        .dispatch('Auth/login', this.form)
        .then(({ roleId, verified, student, classroomStatus, classroomStatusDetail, cerdasTypeId }) => {
          if (roleId === 1 && verified) {
            this.$router.push({ name: 'ReportAdminIndex' });
          } else if (roleId === 2 && verified) {
            this.$router.push({ name: 'MasterUserSchool' });
          } else if (roleId === 6 && verified) {
            this.$router.push({ name: 'StudentIndex' });
          } else if (roleId === 3 && verified && student == true && classroomStatus == true) {
            this.$router.push({ name: 'ChildList' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == true && classroomStatusDetail == true) {
            this.$router.push({ name: 'ParentClassIndex' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == true && classroomStatusDetail == false) {
            this.$router.push({ name: 'ChildList' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == false) {
            this.$router.push({ name: 'ParentClassIndex' });
          } else if (roleId === 4 && verified && cerdasTypeId === 1) {
            this.$store.commit('Auth/SET_GUIDE_POP', { guidePopUp: true });
            this.$router.push({ name: 'CourseIndex' });
          } else if (roleId === 4 && verified && cerdasTypeId === 2) {
            this.$router.push({ name: 'TeacherClassIndex' });
          } else if (roleId === 5 && verified) {
            this.$router.push({ name: 'StudentClassIndex' });
          } else if (roleId && !verified) {
            this.$router.push({ name: 'AuthChangePassword' });
          }
          localStorage.setItem('notif', 0);
        })
        .finally(() => {
          this.loading = false;
          this.$v.$reset();
        });
    },
    verifyDeleteAccount() {
      this.loading = true;
      this.$store
        .dispatch('Auth/verifyDeleteAccount', this.form)
        .then(() => {
          this.$router.push({ name: 'AccountInformation' });
        })
        .finally(() => {
          this.loading = false;
          this.$v.$reset();
        });
    }
  },
  created() {
    this.$store.commit('Auth/SET_GOOGLE_AUTH_CLEAR');
    if (this.isAuthenticated && !Object.keys(this.$route.query).length) {
      const redirect = ['ReportAdminIndex', 'MasterUserSchool', 'ChildList', 'TeacherClassIndex', 'StudentCourseIndex'];
      this.$router.push({ name: redirect[this.currentRole - 1] });
    } else if (!this.isProcessDeleteAccount) {
      this.$i18n.locale = 'en';
      this.axios.defaults.headers.common['Accept-Language'] = 'en';
      localStorage.setItem('LANG', 'en');
    }

    if (Object.keys(this.$route.query).length && this.isProcessDeleteAccount) {
      this.emailTruncate = this.$route.query.email;
    }
  },
  mounted() {
    socketChat.disconnect();
  }
};
</script>

<style lang="scss" scoped>
.dont-have-an-accoun {
  color: #acacac;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 14px;
  text-align: left;
}

.forgot {
  color: #ce8800;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 14px;
  text-align: left;
}
</style>
